import { createSelector } from 'reselect';

import { DataListState } from './data-list.state';

export const ANNOUNCEMENTS = 'announcements';
export const CHECK_INS = 'checkIns';
export const CUSTOMER_TEAM = 'customerTeam';
export const CUSTOMERS = 'customers';
export const FEEDBACK = 'feedback';
export const MEMO_CATEGORIES = 'memoCategories';
export const ORGANISATIONS = 'organisations';
export const ORGANISATION_BRANDING = 'organisationBranding';
export const STAFF = 'staff';

export type Segment =
  | typeof ANNOUNCEMENTS
  | typeof CHECK_INS
  | typeof CUSTOMERS
  | typeof CUSTOMER_TEAM
  | typeof FEEDBACK
  | typeof MEMO_CATEGORIES
  | typeof ORGANISATIONS
  | typeof ORGANISATION_BRANDING
  | typeof STAFF;

export const stateSegment = (segment: Segment) => (superState: any) => superState[segment];

const reducers: any = {};
[
  ANNOUNCEMENTS,
  CHECK_INS,
  CUSTOMERS,
  CUSTOMER_TEAM,
  FEEDBACK,
  MEMO_CATEGORIES,
  ORGANISATIONS,
  ORGANISATION_BRANDING,
  STAFF
].forEach(selector => {
  reducers[selector] = {};
  reducers[selector].getIds = createSelector(
    stateSegment.call(this, selector),
    (state: DataListState<any>) => state.ids
  );
  reducers[selector].getEntities = createSelector(
    stateSegment.call(this, selector),
    (state: DataListState<any>) => state.entities
  );
  reducers[selector].getAll = createSelector(
    reducers[selector].getEntities,
    reducers[selector].getIds,
    (entities, ids: Array<any>) => ids.map(id => entities[id])
  );
  reducers[selector].getSelectedId = createSelector(
    stateSegment.call(this, selector),
    (state: DataListState<any>) => state.selectedId
  );
  reducers[selector].getSelected = createSelector(
    stateSegment.call(this, selector),
    (state: DataListState<any>) => state.entities[state.selectedId]
  );
  reducers[selector].getError = createSelector(
    stateSegment.call(this, selector),
    (state: DataListState<any>) => state.error
  );
  reducers[selector].getLoadingEntities = createSelector(
    stateSegment.call(this, selector),
    (state: DataListState<any>) => state.loadingEntities
  );
  reducers[selector].getLoadingAll = createSelector(
    stateSegment.call(this, selector),
    (state: DataListState<any>) => state.loadingAll
  );
  reducers[selector].getCreating = createSelector(
    stateSegment.call(this, selector),
    (state: DataListState<any>) => state.creating
  );
  reducers[selector].getPagination = createSelector(
    stateSegment.call(this, selector),
    (state: DataListState<any>) => state.page
  );
  reducers[selector].getFilter = createSelector(
    stateSegment.call(this, selector),
    (state: DataListState<any>) => state.filter
  );
  reducers[selector].getSearching = createSelector(
    stateSegment.call(this, selector),
    (state: DataListState<any>) => state.searching
  );
  reducers[selector].getSearchResults = createSelector(
    stateSegment.call(this, selector),
    (state: DataListState<any>) => state.searchResults.map(id => state.entities[id])
  );
});

export const getAll = (segment: Segment) => reducers[segment].getAll;
export const getCreating = (segment: Segment) => reducers[segment].getCreating;
export const getEntities = (segment: Segment) => reducers[segment].getEntities;
export const getError = (segment: Segment) => reducers[segment].getError;
export const getFilter = (segment: Segment) => reducers[segment].getFilter;
export const getIds = (segment: Segment) => reducers[segment].getIds;
export const getLoadingAll = (segment: Segment) => reducers[segment].getLoadingAll;
export const getLoadingEntities = (segment: Segment) => reducers[segment].getLoadingEntities;
export const getPageination = (segment: Segment) => reducers[segment].getPagination;
export const getSearching = (segment: Segment) => reducers[segment].getSearching;
export const getSearchResults = (segment: Segment) => reducers[segment].getSearchResults;
export const getSelected = (segment: Segment) => reducers[segment].getSelected;
export const getSelectedId = (segment: Segment) => reducers[segment].getSelectedId;
